// Configuration file to toggle between mock and real API data
export const MOCK_CONFIG = {
  // Set to true to use mock data, false to use real API
  USE_MOCK_VEHICLE_DATA: false,

  // Set to true to use mock data for other APIs
  USE_MOCK_DASHBOARD_DATA: false,
  USE_MOCK_ORDERS_DATA: false,

  // Console logging for debugging
  LOG_MOCK_USAGE: true,
}

// Helper function to log mock usage
export const logMockUsage = (apiName: string, isMock: boolean) => {
  if (MOCK_CONFIG.LOG_MOCK_USAGE) {
    const icon = isMock ? '🚗' : '🌐'
    const status = isMock ? 'MOCK' : 'REAL'
    console.log(`${icon} ${apiName}: Using ${status} data`)
  }
}
